import { GET_CART_DETAILS, GENERATE_UNIQUE_NO, PAYMENT_ACTION_TYPE, SAVE_FOR_LATER, REMOVE_ORDER, ADD_TO_CART, } from "../../utils/constants"


const initialState = [];

function cartReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_CART_DETAILS:
            return [...state, payload];
        case SAVE_FOR_LATER:
            return [...state, payload];
        case REMOVE_ORDER:
            return [...state, payload];
        case ADD_TO_CART:
            return [...state, payload];
        case PAYMENT_ACTION_TYPE:
            return [...state, payload];
        case GENERATE_UNIQUE_NO:
            return [...state, payload];
        default:
            return state;
    }
};

export default cartReducer;
